<template>
    <div class="body d-flex py-lg-3 py-md-2">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                    <div class="card border-0 mb-2 no-bg">
                        <div
                            class="card-header py-1 px-0 d-sm-flex align-items-center justify-content-between main-button-area">
                            <div class="header-section">
                                <div class="search-area mt-2">
                                    <input id="main-search-input" type="search" class="form-control"
                                        placeholder="Αναζήτηση..." aria-label="search"
                                        aria-describedby="addon-wrapping" />

                                </div>

                            </div>

                            <div class="d-flex mt-sm-0 mt-3 justify-content-between">
                                <button v-if="canCreateList || superUser" type="button" class="ms-0 ms-sm-3 btn btn-dark"
                                    style="color:var(--secondary-color); font-weight:bold"
                                    @click.prevent="createList"><i class="icofont-plus me-2 fs-6"></i>New
                                    list</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row clearfix g-1">
                <div class="col-lg-12">
                    <div>
                        <div class="card-body table-responsive">
                            <TableLists :columns="columns" :data="data" :paginationLinks="paginationLinks"
                                :archiveContacts="archiveContacts" :tableOptions="tableOptions"
                                :isLinkColumn="isLinkColumn" :sortBy="sortBy" :refreshTable="fetchData" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="modal fade" id="create-list-form" tabindex="-1" aria-labelledby="createprojectlLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="createprojectlLabel">Στοιχεία λίστας</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <input name="id" id="id" type="hidden" v-model="listData.id" />

                        <div class="mb-3">
                            <label for="title" class="form-label">Title</label>
                            <input type="text" class="form-control" id="title" v-model="listData.title"
                                placeholder="Title">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Κλείσιμο</button>
                        <button type="button" class="btn btn-secondary" @click="submitForm">Αποθήκευση</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useFetchData } from '@/composables/useFetchData';
import { fetchAll, get } from '@/services/lists';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import TableLists from '@/components/TableLists.vue';
import { deleteList } from '@/services/lists';
import { create } from '@/services/lists';

const defaultListData = {
    title: ''
};

export default {
    name: 'Lists',
    components: {
        Editor,
        Select2,
        TableLists
    },
    methods: {
    },
    computed: {
        ...mapGetters({
            getUserPermission: 'getUserPermission',
            getSuperUserPermission: 'getSuperUserPermission', // Add this line

        }),
        superUser() {
            return this.getSuperUserPermission === 1;
        },
        userPermissions() {
            return this.getUserPermission('Lists');
        },

        canEditAllLists() {
            return this.userPermissions?.editAll === 1;
        },
        canCreateList() {
            return this.userPermissions?.create === 1;
        },
        canArchive() {
            return this.userPermissions?.archive === 1;
        },
    },
    setup() {
        const allData = ref({});

        const route = useRoute();
        const router = useRouter();

        const { data, paginationLinks, filters, updateFilters, fetchData, sortBy } = useFetchData(fetchAll, { page: route.query.page || 1 });

        const listData = ref(defaultListData);
        const selectedListIds = ref([]);
        const tableOptions = { path: 'lists', singlePagePath: 'list-profile' };
        const isDropdownOpen = ref(false);

        const columns = ref([
            { value: "title", label: "Title" },
            { value: "username", label: " Created By" },
            { value: "created_at", label: "Created Date" },

        ]);


        const archiveLists = async (selectedListIds) => {
            if (!selectedListIds.length) {
                useToast().error('Δεν έχετε επιλέξει λίστες');
                return;
            }
            const response = await deleteList({ ids: selectedListIds });
            if (response.data.success) {
                useToast().success(response.data.message);
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const editList = async (id) => {
            const listInfo = await get({ "id": id });
            if (listInfo.data.success) {
                listData.value.id = clientInfo.data.data.id;
                listData.value.title = clientInfo.data.data.title;
            }
            $("#create-list-form").modal('toggle');
        };

        const createList = async () => {
            $("#create-list-form").modal('toggle');
        };

        const submitForm = async () => {
            let finalListData = listData;
            finalListData.value.filter_data = filters.value;
            const response = await create(finalListData.value);
            if (response.data.success) {
                useToast().success(response.data.message);
                $("#create-list-form").modal('toggle');
                fetchData();
            } else {
                useToast().error(response.data.message);
            }
        };

        const getPageFromUrl = (url) => {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        };

        const closeMenu = (event) => {
            if (document.querySelector('.dropdown-menu').length && !document.querySelector('.dropdown-menu').contains(event.target) && !document.querySelector('.dropdown-menu-toggler').contains(event.target)) {
                isDropdownOpen.value = false;
            }
        };

        const dropdownStyle = computed(() => ({
            top: isDropdownOpen.value ? '100%' : 'initial',
            right: isDropdownOpen.value ? '0' : 'initial'
        }));

        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
        };

        const closeDropdown = () => {
            isDropdownOpen.value = false;
        };

        const searchAction = () => {
            setTimeout(() => {
                router.push({ path: '/lists', query: { ...route.query, search: $("#main-search-input").val() } });
            }, 300);
        };

        onMounted(() => {
            $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
            document.addEventListener('click', closeMenu);
        });

        onUnmounted(() => {
            $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
            document.removeEventListener('click', closeMenu);
        });

        const isLinkColumn = (value) => {
            return value == 'title' ? true : false;
        };

        return {
            isLinkColumn, tableOptions, columns, data, allData, paginationLinks, filters, updateFilters, fetchData, getPageFromUrl, listData, submitForm, editList, createList, archiveLists, dropdownStyle, closeDropdown, isDropdownOpen, toggleDropdown, sortBy
        };
    },
    metaInfo: {
        title: 'Λίστες',
        meta: [
            { name: 'description', content: 'MIS - Λίστες' },
            { property: 'og:title', content: 'MIS - Λίστες' },
            { property: 'og:description', content: 'This is the lists page.' }
        ]
    }
};
</script>

<style scoped>
.dropdown-menu.show {
    display: block;
}

tr.selected,
div.selected {
    background: #b1afaf;
}
</style>
